import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './Login.css';
import '../../globalcss.css';
import facebookround from '../../Images/facebookround.png';
import twitterround from '../../Images/twitterround.png';
import googleplus from '../../Images/google-plus.png';
import { connect } from "react-redux";
import { NavLink, withRouter } from 'react-router-dom';
import { Row, Col, Button, Form, Input } from 'antd';
import * as loginAction from '../../redux/action';
import { bindActionCreators } from 'redux';
import SocialButton from '../SocialButton/SocialButton';
import 'react-loading-bar/dist/index.css';
// import TwitterLogin from 'react-twitter-auth/lib/react-twitter-auth-component.js';

const FormItem = Form.Item;

class Login extends Component {

    handleCancel = (e) => {
        if (typeof this.props.handleCancel === 'function') {
            this.props.handleCancel();
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            OSName: 'Unknown',
        }
        
        this.handleSubmit = this.handleSubmit.bind(this);
        if (this.props.loggeduserDetails.name) {
            this.props.history.push('/home');
        }
    }

    componentDidMount() {
        console.log(navigator)
        console.log("jgnvjhwecfrdfv", this.props.history);
        this.props.actions.userdetails(localStorage.getItem('session'));
        if (navigator.appVersion.indexOf("Win") != -1) this.setState({ OSName: "Windows" });
        if (navigator.appVersion.indexOf("Mac") != -1) this.setState({ OSName: "MacOS" });
        if (navigator.appVersion.indexOf("X11") != -1) this.setState({ OSName: "UNIX" });
        if (navigator.appVersion.indexOf("Linux") != -1) this.setState({ OSName: "Linux" });

     
        // function to scrollto top
        // aradhana

        window.scrollTo(0, 0)
    }

    // LOGIN FUNCTION
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(values)
                let data = {
                    password: values.password,
                    email: values.email,
                    deviceInfo:
                    {
                        platform: "Web",
                        "model": navigator.appCodeName,
                        "os": this.state.OSName,
                        "deviceId": navigator.productSub
                    }
                }
                this.props.actions.login(data, this.props.history);
            }
        });
        this.props.form.setFieldsValue({
            ['email']: '',
            ['password']: ''
        })

    }

    // social login api
    handleSocialLogin = (user) => {
        console.log(user);
        let data = {
            uId: user._profile.id,
            provider: user._provider,
            name: user._profile.name,
            email: user._profile.email,
            imageUrl: user._profile.profilePicURL,
            deviceInfo: [{
                platform: "web",
                model: navigator.appCodeName,
                os: "MacOs",
                deviceId: navigator.productSub
            }]
        }
        this.props.actions.socialLogin(data, this.props.history);
        this.props.handleCancel();
    }

    // if error in social,login
    handleSocialLoginFailure = (err) => {
        console.error(err)
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="loginsec">

                {/* login us start */}
                <div className="loginsection">
                    <Row type="flex" justify="center">
                        <Col lg={{ span: 24 }} xs={{ span: 22 }}>
                            <div className="loginForm">

                                {/* login form start */}
                                <Form onSubmit={(e) => { this.handleSubmit(e); this.handleCancel(); }} className="login-form">
                                    <Row type="flex" justify="center">
                                        <Col lg={{ span: 22 }} xs={{ span: 24 }}>

                                            <FormItem className="emailcont">
                                                {getFieldDecorator('email', {
                                                    rules: [{
                                                        type: 'email', message: 'The input is not valid E-mail!'
                                                    },
                                                    { required: true, message: 'Please input your username!' }],
                                                })(
                                                    <Input placeholder="Username" autoComplete="Off" />
                                                )}
                                            </FormItem>

                                            <FormItem className="emailcont">
                                                {getFieldDecorator('password', {
                                                    rules: [{ required: true, message: 'Please input your Password!' }
                                                    ],
                                                })(
                                                    <Input type="password" placeholder="Password" />
                                                )}
                                            </FormItem>

                                            <FormItem className="text-center">
                                                <Button
                                                    type="primary"
                                                    htmlType="submit">
                                                    Login
                                                </Button>
                                            </FormItem>
                                        </Col>
                                    </Row>

                                    {/* social login section start*/}
                                    <Row type="flex" justify="center">
                                        <Col lg={{ span: 22 }} xs={{ span: 24 }}>
                                            <p className="socialloginheading">Or Login with</p>
                                            <ul className="list-inline">
                                                <li><SocialButton
                                                    provider='facebook'
                                                    appId='295843974524713'
                                                    onLoginSuccess={this.handleSocialLogin}
                                                    onLoginFailure={this.handleSocialLoginFailure}
                                                >
                                                    <img src={facebookround} alt="tapmenow" />
                                                </SocialButton></li>
                                                <li>
                                                    <a href='#'>
                                                        <img src={twitterround} alt="tapmenow" />
                                                    </a>
                                                </li>
                                                <li><SocialButton
                                                    provider='google'
                                                    appId='933492990654-qc1odg8pn2s062at4u26bq51oo6lb8do.apps.googleusercontent.com'
                                                    onLoginSuccess={this.handleSocialLogin}
                                                    onLoginFailure={this.handleSocialLoginFailure}
                                                >
                                                    <img src={googleplus} alt="tapmenow" />
                                                </SocialButton></li>
                                            </ul>
                                        </Col>
                                    </Row>
                                    {/* social login section end*/}

                                </Form>
                                {/* login form end */}

                            </div>
                        </Col>
                    </Row>

                    {/* forget password section */}
                    <Row type="flex" justify="center">
                        <Col lg={{ span: 8 }} xs={{ span: 10 }} className="text-center">
                            <h5 className="forgetsignup"><NavLink to="/forgetpwd">Forgot Password ?</NavLink></h5>
                        </Col>
                    </Row>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    console.log('login screen info', state)
    return state

}

function mapDispatchToProps(dispatch, state) {
    return ({
        actions: bindActionCreators(loginAction, dispatch)
    })
}
const WrappedNormalLoginForm = Form.create()(Login);
//export default WrappedNormalLoginForm;


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm));



// WEBPACK FOOTER //
// ./src/Component/Login/Login.js